<template>
  <div class="w-full">
    <label class="label" :for="label">
      {{ label }}
    </label>
    <div v-if="!image">
      <input class="hidden-input" :name="field" v-validate="validationRule" v-model="image" />
      <label class="custom-file-upload">
        <input class="bg-white hover:bg-grey-lightest text-grey-darkest font-semibold py-2 px-4 border border-grey-light rounded shadow" @change.prevent="onFileChange" :name="field" :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field)}" :id="label" type="file"> Choose Files
      </label>
    </div>
    <div class="flex" v-else>
      <div class="flex flex-col items-center">
        <img :class="{'field': true, 'preview-image': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field)}" :id="label" :src="image" />
        <label class="label">{{fileName}}</label>
        <button class="bg-white hover:bg-grey-lightest text-grey-darkest font-semibold py-2 px-4 border border-grey-light rounded shadow" @click.prevent="removeImage">Remove</button>
      </div>
    </div>
    <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">{{ validationMessage }}</p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import PDFLogo from '@/assets/PDF-Logo.jpg';
import uuid from 'uuid/v4';

export default {
  name: 'FieldFile',
  inject: ['$validator'],
  data() {
    return {
      image: '',
      imageData: {},
      fileName: '',
      uniqueId: uuid(),
    };
  },
  props: {
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapMutations({
      setField: 'broker/setField',
    }),
    onFileChange(e) {
      // listen for file being uploaded to DOM
      // upload is in an array
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      // create appropriate image and file readers to get meta data
      const reader = new FileReader();
      const vm = this;
      console.log('file', file)
      // preserve the context of this
      reader.onload = e => {
        if (file.type === 'application/pdf') {
          vm.image = PDFLogo;
        } else {
          vm.image = e.target.result;
        }
        vm.fileName = file.name;
        vm.imageData = file;
        vm.upload(file);
      };
      reader.readAsDataURL(file);
    },
    async removeImage(e) {
      const { name } = this.imageData;
      try {
        await this.$http.post('aggregatorAssets/assetUrl', {
          name: `${this.uniqueId}-${name}`,
        });
        this.image = '';
        this.setField({ field: this.field, value: '' });
      } catch (e) {
        this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not delete image'}`)
      }
    },
    async upload(file) {
      const { type, name } = file;
      try {
        const data = await this.$http.post('aggregatorAssets/signedUrl', {
          name: `${this.uniqueId}-${name.replace(/\s/g, '')}`,
          type,
        });
        // we get back two urls, temp url to upload to S3 and destination url (finalURL) where the data actually sits
        const { uploadURL, finalURL } = data.body;
        this.uploadToAws(uploadURL, file);
        this.setField({ field: this.field, value: finalURL });
      } catch (e) {
        this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not upload image'}`)
      }
    },
    uploadToAws(url, file) {
      const req = new XMLHttpRequest();

      // check for upload function
      if (req.upload) {
        req.open('PUT', url, true);
      }
      req.send(file);
    },
  },
};
</script>
<style lang="postcss" scoped>
input[type='file'] {
  display: none;
}
.hidden-input {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: gray;
}
.preview-image {
  height: 100px;
  width: 100px;
  position: relative;
}
.delete-button {
  border: 1px solid black;
  background-color: 'black';
  color: 'white';
}
</style>



// WEBPACK FOOTER //
// src/components/FieldFile.vue